import React, { Fragment } from "react";
import { Snackbar, Slide, Alert } from "@mui/material";
import { withTranslation } from "react-i18next";

let triggerGlobalError;

export function setupGlobalErrorHandlers() {
  window.onerror = (msg, url, line, col, error) => {
    const errorMessage = `Error: ${msg}\nurl: ${url}\nline: ${line}\ncolumn: ${col}\nerror: ${error}`;

    if (triggerGlobalError) {
      triggerGlobalError(true); // Show Snackbar
    }

    return true; // Prevent default error handling
  };

  window.onunhandledrejection = (e) => {
    const reason = e.reason;
    let errorMessage = "Unhandled Promise Rejection";
    if (reason instanceof Error) {
      errorMessage += `: ${reason.message}\nStack: ${reason.stack}`;
    } else {
      errorMessage += `: ${reason}`;
    }

    if (triggerGlobalError) {
      triggerGlobalError(true); // Show Snackbar
    }
  };
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    triggerGlobalError = this.triggerError;
  }

  triggerError = (hasError) => {
    if (hasError && !this.state.hasError) {
      this.setState({ hasError: true }, () => {
        // Automatically close the Snackbar after 10 seconds
        setTimeout(() => {
          this.setState({ hasError: false });
        }, 10000); // 10000 ms = 10 seconds
      });
    }
  };

  static getDerivedStateFromError(error) {
    return { hasError: true }; // Update state to show fallback UI
  }

  componentDidCatch(error, errorInfo) {}

  render() {
    const { hasError } = this.state;
    const { t } = this.props;
    if (hasError) {
      return (
        <Fragment>
          <Snackbar
            open={hasError}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            TransitionComponent={(props) => (
              <Slide {...props} direction="down" />
            )}
            autoHideDuration={10000}
            onClose={() => this.setState({ hasError: false })}
            ClickAwayListenerProps={{
              mouseEvent: false,
              touchEvent: false,
            }}
          >
            <Alert severity="warning" variant="filled" sx={{ width: "100%" }}>
              {t("ErrorBoundaryDisplayMessage")}
            </Alert>
          </Snackbar>
          {this.props.children}
        </Fragment>
      );
    }
    return <Fragment>{this.props.children}</Fragment>;
  }
}

export default withTranslation()(ErrorBoundary);
